<template>
  <v-row>
    <v-col cols="12">
      <base-card>
        <v-row>
          <v-col cols="9" md="11"
            ><v-card-title
              >{{ $t("dailySalesPage.dailySalesChart") }}
              <span>({{ date }})</span></v-card-title
            ></v-col
          >
          <v-col cols="3" md="1">
            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="date"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="mt-3" icon>
                  <v-icon>mdi-calendar</v-icon>
                </v-btn>
              </template>
              <v-date-picker v-model="date" type="month" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="$refs.dialog.save(date)">
                  {{ $t("salesSummaryPage.choose") }}
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="5" md="3" class="ml-4">
            <v-select
              class="mt-3"
              v-model="selectBranch"
              :items="branchList"
              item-text="name"
              item-value="branch_id"
              outlined
              dense
            ></v-select
          ></v-col>
        </v-row>
        <v-row>
          <v-col>
            <div v-show="showChart">
              <apexchart :options="chartOptions" :series="series" />
            </div>
          </v-col>
        </v-row>
      </base-card>
    </v-col>
    <v-col cols="12">
      <base-card>
        <div class="d-flex align-center justify-space-between pr-3">
          <v-card-title
            >{{ $t("dailySalesPage.dailySalesTable") }}
          </v-card-title>
          <v-spacer></v-spacer>
          <!-- <v-btn
            color="blue-grey"
            class="ma-2 white--text"
            @click="dialogStepper = true"
          >
            SQL Export
          </v-btn> -->
          <div v-if="salesList.length != 0">
            <export-excel
              :data="salesListToPrint"
              :fields="json_fields"
              :name="filename"
            >
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on"> mdi-download </v-icon>
                </template>
                <span
                  >{{ $t("dailySalesPage.downloadDailySalesReport") }}
                </span>
              </v-tooltip>
            </export-excel>
          </div>
        </div>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="salesList"
            :page.sync="page"
            :no-data-text="$t('dailyModifierSalesPage.noData')"
            :items-per-page="itemsPerPage"
            @page-count="pageCount = $event"
            item-key="sales_id"
          >
            <template v-slot:item.charge="{ item }">
              <span v-if="item.charge != null && item.charge != ''">{{
                item.charge
              }}</span>
              <span v-else>0.00</span>
            </template>
          </v-data-table>
          <!-- <div class="text-center py-2">
            <v-pagination v-model="page" :length="pageCount"></v-pagination>
          </div> -->
        </v-card-text>
      </base-card>
      <v-dialog v-model="dialogStepper" max-width="900px" persistent>
        <v-card>
          <v-card-title> Export Payment Data </v-card-title>
          <v-card-text>
            <v-stepper v-model="step">
              <v-stepper-header>
                <v-stepper-step :complete="step > 1" :step="1">
                  Select Date Range & Branch
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="step > 2" :step="2">
                  Enter SQL Code
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="step > 3" :step="3">
                  Payment Method Code
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :step="4">Export</v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content :step="1">
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-menu
                        v-model="startMenu"
                        :close-on-content-click="false"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="form.startDate"
                            label="Start Date"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="form.startDate"
                          @input="startMenu = false"
                        />
                      </v-menu>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-menu
                        v-model="endMenu"
                        :close-on-content-click="false"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="form.endDate"
                            label="End Date"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="form.endDate"
                          @input="endMenu = false"
                        />
                      </v-menu>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        label="Branch"
                        v-model="form.branch"
                        :items="branchList"
                        item-text="name"
                        item-value="branch_id"
                      />
                    </v-col>
                  </v-row>
                  <v-btn color="primary" @click="goStep2">Next</v-btn>
                </v-stepper-content>
                <v-stepper-content :step="2">
                  <v-textarea
                    v-model="form.sql"
                    label="Enter SQL Code"
                    auto-grow
                  />
                  <v-btn color="primary" @click="goStep3">Next</v-btn>
                  <v-btn text @click="step = 1">Back</v-btn>
                </v-stepper-content>

                <v-stepper-content :step="3">
                  <v-data-table
                    :headers="headerStepper"
                    :items="paymentMethods"
                    item-key="payment_link_company_id"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.SQL_payment_code="{ item }">
                      <v-text-field v-model="item.SQL_payment_code" dense />
                    </template>
                  </v-data-table>

                  <v-btn color="primary" :loading="dataLoading" @click="goStep4">Next</v-btn>
                  <v-btn text @click="step = 2">Back</v-btn>
                </v-stepper-content>
                <v-stepper-content :step="4">
                  <ExportPaymentTemplate :data="paymentData"></ExportPaymentTemplate>
                  <v-btn text class="mx-4" @click="step = 3">Back</v-btn>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeDialog">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="timeout">
        {{ text }}

        <template v-slot:action="{ attrs }">
          <v-btn dark icon v-bind="attrs" @click="snackbar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </v-col>
  </v-row>
</template>
  <script>
import { BASEURL } from "@/api/baseurl";
import axios from "axios";
import TestCard from "@/components/card/TestCard";
import PriceCard from "@/components/card/PriceCard";
import VueHtml2pdf from "vue-html2pdf";
import ExportPaymentTemplate from "@/components/template/ExportPaymentTemplate.vue";

export default {
  name: "Sales",
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: "Sales",
  },
  components: {
    "test-card": TestCard,
    "price-card": PriceCard,
    VueHtml2pdf,
    ExportPaymentTemplate,
  },
  data() {
    return {
      json_fields: {
        id: "sales_id",
        Branch: "name",
        Date: "date",
        "Gross Sales": "grossSales",
        "Discount amount": "promotion",
        Charge: {
          field: "charge",
          callback: (value) => {
            if (value != "") {
              return value;
            } else {
              return "0.00";
            }
          },
        },
        "Net Sales": "netsales",
        Tax: "tax",
        Rouding: "rounding",
        Sales: "total_amount",
      },
      domain: BASEURL,
      company_id: "",
      showIcon: false,
      showChart: false,
      date: "",
      modal: false,

      //dialog stepper
      dialogStepper: false,
      step: 1,
      startMenu: false,
      endMenu: false,
      form: {
        startDate: "",
        endDate: "",
        branch: null,
        sql: "",
      },
      dataLoading: false,
      snackbar: false,
      text: "",
      snackbarColor: "",
      timeout: 1900,
      headerStepper: [
        { text: "Payment Method", value: "name" },
        { text: "Code", value: "SQL_payment_code" },
      ],
      paymentData: [],
      paymentMethods: [],

      //end
      branchList: [],
      salesList: [],
      selectBranch: "",
      salesListToPrint: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,

      //chart
      series: [
        {
          name: "Sales",
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          height: 300,
          width: 600,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          type: "Date/Month/Year",
        },
      },
    };
  },
  computed: {
    filename() {
      return "Daily Sales Report_" + this.date + ".xls";
    },
    headers() {
      return [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "sales_id",
        },

        {
          text: this.$t("salesSummaryPage.branch"),
          align: "start",
          sortable: false,
          value: "name",
        },

        {
          text: this.$t("dailySalesPage.date"),
          align: "start",
          value: "date",
          sortable: false,
        },

        {
          text: this.$t("dailySalesPage.salesAmount"),
          align: "start",
          sortable: false,
          value: "total_amount",
        },

        {
          text: "Rounding",
          align: "start",
          sortable: false,
          value: "rounding",
        },

        {
          text: this.$t("dailySalesPage.tax"),
          align: "start",
          value: "tax",
          sortable: false,
        },

        {
          text: this.$t("dailySalesPage.charge"),
          align: "start",
          value: "charge",
          sortable: false,
        },

        {
          text: this.$t("dailySalesPage.promotion"),
          align: "start",
          value: "promotion",
          sortable: false,
        },

        {
          text: this.$t("salesSummaryPage.grossSales"),
          align: "start",
          value: "grossSales",
          sortable: false,
        },

        {
          text: this.$t("dailySalesPage.netSales"),
          align: "start",
          value: "netsales",
          sortable: false,
        },
      ];
    },
  },
  watch: {
    date() {
      this.salesList = [];
      this.getAllSettlement();
    },
    selectBranch() {
      this.salesList = [];
      this.getAllSettlement();
    },
    "form.branch"() {
      this.getBranchSQLcode(this.form.branch);
    },
  },
  created() {
    var CryptoJS = require("crypto-js");
    var x = localStorage.getItem("userInfo");
    // Decrypt
    var bytes = CryptoJS.AES.decrypt(x, "secret key 123");
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    this.companyID = decryptedData.company_id;
    this.getCompanyBranch();
  },
  methods: {
    //method for stepper
    getBranchSQLcode(branchID) {
      const params = new URLSearchParams();
      params.append("getBranchSQLcode", "done");
      params.append("branch_id", branchID);

      axios({
        method: "post",
        url: this.domain + "/branch/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.form.sql = response.data.branch[0].SQL_export_code;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateBranchSQLcode(sql, branchID) {
      const params = new URLSearchParams();
      params.append("updateBranchSQLcode", "done");
      params.append("branch_id", branchID);
      params.append("SQL_export_code", sql);

      axios({
        method: "post",
        url: this.domain + "/branch/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            console.log("update successfully");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    updatePaymentSQLcode() {
      const params = new URLSearchParams();
      params.append("updatePaymentSQLcode", "done");
      params.append("payment_list", JSON.stringify(this.paymentMethods));
      params.append("company_id", this.companyID);

      axios({
        method: "post",
        url: this.domain + "/payment/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            console.log("update successfully");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getSQLExportList() {
      const params = new URLSearchParams();
      params.append("getSQLExportList", "done");
      params.append("company_id", this.companyID);
      params.append("branch_id", this.form.branch);
      params.append("first_date", this.form.startDate);
      params.append("second_date", this.form.endDate);
      axios({
        method: "post",
        url: this.domain + "/report/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            console.log(response.data.report);
            this.dataLoading = false;
            this.step = 4;
            this.paymentData = response.data.report;
            
          }else{
             this.dataLoading = false;
             this.paymentData = [];
             this.text = "No data to export, please check your SQL code or the date range you selected.";
             this.snackbar = true;
             this.snackbarColor = "warning";
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getPaymentTypeAndCode(companyID) {
      const params = new URLSearchParams();
      params.append("getPaymentTypeAndCode", "done");
      params.append("company_id", companyID);

      axios({
        method: "post",
        url: this.domain + "/payment/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.paymentMethods = response.data.payment;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goStep2() {
      if (!this.form.startDate || !this.form.endDate || !this.form.branch) {
        this.text = "Please fill up all the field";
        this.snackbar = true;
        this.snackbarColor = "warning";
        return;
      }
      this.getPaymentTypeAndCode(this.companyID);
      this.step = 2;
    },

    closeDialog() {
      this.dialogStepper = false;
      this.step = 1;
      this.form = {
        startDate: "",
        endDate: "",
        branch: null,
        sql: "",
      };
    },
    goStep3() {
      if (!this.form.sql) {
        this.text = "Please fill up the SQL Code ";
        this.snackbar = true;
        this.snackbarColor = "warning";
        return;
      }
      this.updateBranchSQLcode(this.form.sql, this.form.branch);
      
      this.step = 3;
    },

    goStep4() {
      const hasEmpty = this.paymentMethods.some(
        (item) => !item.SQL_payment_code || item.SQL_payment_code.trim() === ""
      );

      if (hasEmpty) {
        this.text = "Please fill up the SQL Payment Code ";
        this.snackbar = true;
        this.snackbarColor = "warning";
        return;
      }
      this.dataLoading = true;
      this.updatePaymentSQLcode();
      this.getSQLExportList();
    },
    //

    getAllSettlement() {
      const params = new URLSearchParams();
      params.append("getSalePerDayList", "done");
      params.append("branch_id", this.selectBranch);
      params.append("month", this.date);

      axios({
        method: "post",
        url: this.domain + "/report/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);

          if (response.data.status == "1") {
            this.series = [
              {
                name: "Sales",
                data: [],
              },
            ];
            var moment = require("moment");
            this.salesList = response.data.report;
            this.showChart = true;

            var currentMonthDates = Array(
              moment(this.date, "YYYY-MM").daysInMonth()
            )
              .fill(null)
              .map((x, i) => moment(this.date).startOf("month").add(i, "days"));

            for (let i = 0; i < currentMonthDates.length; i++) {
              var obj = { x: "", y: "" };
              obj.x = moment(currentMonthDates[i]).format("DD-MM-YYYY");
              obj.y = 0.0;
              this.series[0].data.push(obj);
            }

            for (let j = 0; j < this.salesList.length; j++) {
              const index = this.series[0].data.findIndex((obj) => {
                return (
                  obj.x === moment(this.salesList[j].date).format("DD-MM-YYYY")
                );
              });
              this.series[0].data[index].x = moment(
                this.salesList[j].date
              ).format("DD-MM-YYYY");
              this.series[0].data[index].y = this.salesList[j].total_amount;
            }

            this.salesListToPrint = [...this.salesList];

            const totalSalesAmountSum = this.salesListToPrint.reduce(
              (sum, entry) => sum + parseFloat(entry.total_amount) || 0,
              0
            );

            const totalRoundingSum = this.salesListToPrint.reduce(
              (sum, entry) => sum + parseFloat(entry.rounding) || 0,
              0
            );

            const totalTaxSum = this.salesListToPrint.reduce(
              (sum, entry) => sum + parseFloat(entry.tax) || 0,
              0
            );

            const totalChargeSum = this.salesListToPrint.reduce(
              (sum, entry) => sum + parseFloat(entry.charge) || 0,
              0
            );

            const totalPromotionSum = this.salesListToPrint.reduce(
              (sum, entry) => sum + parseFloat(entry.promotion) || 0,
              0
            );

            const totalGrossSalesSum = this.salesListToPrint.reduce(
              (sum, entry) => sum + parseFloat(entry.grossSales) || 0,
              0
            );

            const totalNetSalesSum = this.salesListToPrint.reduce(
              (sum, entry) => sum + parseFloat(entry.netsales) || 0,
              0
            );

            // Clone the original data structure but empty other fields
            const summedData = {
              total_amount: totalSalesAmountSum.toFixed(2),
              charge: totalChargeSum.toFixed(2),
              tax: totalTaxSum.toFixed(2),
              rounding: totalRoundingSum.toFixed(2),
              netsales: totalNetSalesSum.toFixed(2),
              promotion: totalPromotionSum.toFixed(2),
              grossSales: totalGrossSalesSum.toFixed(2),
              date: "",
              name: "",
              sales_id: "Total",
            };

            this.salesListToPrint.push(summedData);
          } else {
            this.series = [
              {
                name: "Sales",
                data: [],
              },
            ];
            var moment = require("moment");
            var currentMonthDates = new Array(
              moment(this.date, "YYYY-MM").daysInMonth()
            )
              .fill(null)
              .map((x, i) =>
                moment(this.date, "YYYY-MM").startOf("month").add(i, "days")
              );

            for (let w = 0; w < currentMonthDates.length; w++) {
              var obj = { x: "", y: "" };
              obj.x = moment(currentMonthDates[w]).format("DD-MM-YYYY");
              obj.y = 0.0;
              this.series[0].data.push(obj);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getCompanyBranch() {
      const params = new URLSearchParams();
      params.append("getCompanyBranch", "done");
      params.append("company_id", this.companyID);

      axios({
        method: "post",
        url: this.domain + "/branch/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            var moment = require("moment");
            this.branchList = response.data.branch;
            this.selectBranch = this.branchList[0].branch_id;
            this.date = moment().format("YYYY-MM");
            this.getAllSettlement();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
  <style>
#customers {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
  font-size: large;
}

#customers td,
#customers th {
  border: 1px solid #ddd;
  padding: 8px;
}

#customers tr:nth-child(even) {
  background-color: #f2f2f2;
}

#customers tr:hover {
  background-color: #ddd;
}

#customers th {
  padding-top: 6px;
  padding-bottom: 6px;
  text-align: left;
  background-color: #04aa6d;
  color: white;
}
</style>
  
  
  